import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import menudown from "../src/assets/images/mobile-menu-downarrow.svg";
import menuup from "../src/assets/images/menuup.svg";
import { useTranslation } from "react-i18next";
import SubCategory from "../src/Json/SubCategory.json";
import brands from "../src/Json/Brand.json";
function LibasMenuWatchandjews({
  toggleCategory,
  expandedCategory,
  activeFilter,
  setHide,
  setActiveFilter,
  selectedPageNull,
  categoryContainerVariants,
  subcategoryItemVariants,
  navigateToCategory,
  toggleSubcategory,
  expandedSubcategories,
  nestedMenuVariants,
  nestedItemVariants,
}) {
  const { i18n, t } = useTranslation();
  console.log(expandedSubcategories, "this is exapand");
  const womenJewelryWatch = [
    {
      name: "New In Watches",
      params:
        "/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=WFA967se7qX0jYtySgTj",
      nameAr: "",
    },
    {
      name: "New In Jewellery",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj",
      nameAr: "",
    },
    {
      name: "Bag charms",
      params: "/products?subcategory=pA6VRVYknSalkjfklf",
      nameAr: "",
    },
    {
      name: "Bracelets",
      params: "/products?subcategory=DhlKDrVEqEzryNOmL0n2",
      nameAr: "",
    },
    {
      name: "Earrings",
      params: "/products?subcategory=mtBPHMO5MWBmUvNdCUJF",
      nameAr: "",
    },
    {
      name: "Hair accessories",
      params: "/products?subcategory=WhvbBFPU8ovRs2PD3Afj",
      nameAr: "",
    },
    {
      name: "Jewellery sets",
      params: "/products?subcategory=92V3Z9KOK3bgLgKasr51",
      nameAr: "",
    },
    {
      name: "Necklaces",
      params: "/products?subcategory=3UiCyOIQMzLaWg1pa6E4",
      nameAr: "",
    },
    {
      name: "Pendants",
      params: "/products?subcategory=YGfZxrbhDMH16MzLoObK",
      nameAr: "",
    },
    {
      name: "Pins & brooches",
      params: "/products?subcategory=09NAB58zlxf246G2Zi7h",
      nameAr: "",
    },
    {
      name: "Rings",
      params: "/products?subcategory=YJJJe8JajhHTAk7SCsip",
      nameAr: "",
    },
    {
      name: "All Watches",
      params:
        "/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=WFA967se7qX0jYtySgTj",
      nameAr: "",
    },
    {
      name: "All Jewellery",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj",
      nameAr: "",
    },
  ];
  const menJewelryWatch = [
    {
      name: "New In Watches",
      params:
        "/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=KG3s4pPk3arcBux5ERnD",
      nameAr: "",
    },
    {
      name: "New In Jewellery",
      params:
        "/products?subcategory=X219u0BbTXGaT93w3na9&gender=KG3s4pPk3arcBux5ERnD",
      nameAr: "",
    },
    {
      name: "All Watches",
      params:
        "/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=KG3s4pPk3arcBux5ERnD",
      nameAr: "",
    },
    {
      name: "All Jewellery",
      params:
        "/products?subcategory=X219u0BbTXGaT93w3na9&gender=KG3s4pPk3arcBux5ERnD",
      nameAr: "",
    },
  ];
  const jewelryBrandsSection = [
    { id: "Cartier" },
    { id: "Céline" },
    { id: "Chanel" },
    { id: "Christian Dior" },
    { id: "Dior" },
    { id: "Fendi" },
    { id: "Givenchy" },
    { id: "Gucci" },
    { id: "Hermès" },
    { id: "Kate Spade" },
    { id: "Louis Vuitton" },
    { id: "Tiffany & Co" },
    { id: "Van Cleef & Arpels" },
    { id: "Yves Saint Laurent" },
  ];
  const watchBrandsSection = [
    { id: "Breitling" },
    { id: "Burberry" },
    { id: "Cartier" },
    { id: "Chanel" },
    { id: "Gucci" },
    { id: "Hermès" },
    { id: "Hublot" },
    { id: "Longines" },
    { id: "Louis Vuitton" },
    { id: "Michael Kors" },
    { id: "Omega" },
    { id: "Rolex" },
    { id: "Tag Heuer" },
    { id: "Yves Saint Laurent" },
  ];

  return (
    <div
      className="category-menu"
      style={{
        color: "#404040",
        fontSize: "14px",
      }}
    >
      {/* watchesandjew */}
      <div className="category-item mt-3">
        <motion.div
          className="d-flex justify-content-between align-items-center p-2 px-3"
          onClick={() => toggleCategory("watchesandJewelry")}
          style={{
            borderBottom:
              expandedCategory === "watchesandJewelry"
                ? "none"
                : "1px solid #dee2e6",
            borderBottomColor:
              expandedCategory === "watchesandJewelry" ? "#333" : "#eee",
            borderBottomWidth:
              expandedCategory === "watchesandJewelry" ? "2px" : "1px",
            cursor: "pointer",
          }}
        >
          <div
            // to="/products?id=WJmwaMSWxtl1dK1sPZ1x"
            className="titlemega"
            style={{
              textDecoration: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (activeFilter === "watchesandJewelry") {
                setHide(true);
                return;
              } else {
                setActiveFilter("watchesandJewelry");
                setHide(true);
                selectedPageNull();
              }
            }}
          >
            <motion.span
              className=""
              style={{
                color: "#404040",
                fontWeight:
                  expandedCategory === "watchesandJewelry" ? "500" : "400",
                textDecoration:
                  expandedCategory === "watchesandJewelry"
                    ? "underline"
                    : "none",
              }}
              whileHover={{ scale: 1.02 }}
            >
              {t("watchesandJewelry")}
            </motion.span>
          </div>

          {/* Animated arrow icon */}
          <motion.div
            animate={{ rotate: expandedCategory === "mens" ? 180 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <img
              src={expandedCategory === "watchesandJewelry" ? menuup : menudown}
              alt="menudown"
            />
          </motion.div>
        </motion.div>
        <AnimatePresence>
          {expandedCategory === "watchesandJewelry" && (
            <motion.div
              className="subcategory-container p-1 px-3"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={categoryContainerVariants}
            >
              <div className="row">
                <div className="col-12 p-0">
                  {/* submenus of watchesandJewelry */}
                  <ul className="list-unstyled">
                    {/* women watches and jews with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=WFA967se7qX0jYtySgTj&`}
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "watchesandJewelry") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("watchesandJewelry");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() =>
                              navigateToCategory("watchesandJewelry", "mens")
                            }
                          >
                            Women's
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("womenjewjews");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.womenjewjews
                              ? 180
                              : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.womenjewjews
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for womenjewjews */}
                      <AnimatePresence>
                        {expandedSubcategories?.womenjewjews && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {womenJewelryWatch?.map((sub) => (
                              <Link
                                key={sub.name}
                                to={sub.params}
                                className="subtitlemega"
                                onClick={() => {
                                  if (activeFilter === "watchesandJewelry") {
                                    setHide(true);
                                    return;
                                  } else {
                                    setActiveFilter("watchesandJewelry");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "watchesandJewelry",
                                        "subcategory",
                                        sub.slug || sub.name.toLowerCase()
                                      )
                                    }
                                  >
                                    {i18n.language === "en"
                                      ? sub.name
                                      : sub.nameAr}
                                  </motion.button>
                                </motion.li>
                              </Link>
                            ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/* mens with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=KG3s4pPk3arcBux5ERnD&`}
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "watchesandJewelry") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("watchesandJewelry");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() =>
                              navigateToCategory("watchesandJewelry", "mens")
                            }
                          >
                            Men's
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("meensjewjews");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.meensjewjews
                              ? 180
                              : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.meensjewjews
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for meensjewjews */}
                      <AnimatePresence>
                        {expandedSubcategories?.meensjewjews && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {menJewelryWatch?.map((sub) => (
                              <Link
                                key={sub.name}
                                to={sub.params}
                                className="subtitlemega"
                                onClick={() => {
                                  if (activeFilter === "watchesandJewelry") {
                                    setHide(true);
                                    return;
                                  } else {
                                    setActiveFilter("watchesandJewelry");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "watchesandJewelry",
                                        "subcategory",
                                        sub.slug || sub.name.toLowerCase()
                                      )
                                    }
                                  >
                                    {i18n.language === "en"
                                      ? sub.name
                                      : sub.nameAr}
                                  </motion.button>
                                </motion.li>
                              </Link>
                            ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>
                  </ul>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default LibasMenuWatchandjews;
